// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 522) return "js/522-2a8896a7bb66f87997ce.chunk.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"646":"4d8c70c9a892c7ca0b4c","9304":"cc2b5dc150c5d478ae23"}[chunkId] + ".js";
};